export const REGISTRATION_RECEIPT_COOKIE = "registration_receipt";

export type RegistrationReceipt = {
	method: "email" | "google";
	nonce: string;
};

export function serializeRegistrationReceipt(receipt: RegistrationReceipt) {
	return `${receipt.method}.${receipt.nonce}`;
}

export function parseRegistrationReceipt(
	value: string | null,
): RegistrationReceipt | null {
	if (!value) {
		return null;
	}

	const separator = value.indexOf(".");
	const method = value.slice(0, separator);
	const nonce = value.slice(separator + 1);
	if ((method !== "email" && method !== "google") || !nonce) {
		return null;
	}

	return { method, nonce };
}

export async function reportRegistrationReceipt(dependencies: {
	clear: () => void;
	read: () => string | null;
	send: (method: RegistrationReceipt["method"]) => Promise<boolean>;
}): Promise<"failed" | "none" | "sent"> {
	const receipt = parseRegistrationReceipt(dependencies.read());
	if (!receipt) {
		return "none";
	}

	if (!(await dependencies.send(receipt.method))) {
		return "failed";
	}

	dependencies.clear();
	return "sent";
}
